import { useEffect, useState } from 'react';

export default function ReachabilityBadge({ host }: { host: string }) {
  const [status, setStatus] = useState<'unknown'|'reachable'|'unreachable'>('unknown');

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      const h = (host || '').replace(/^www\./, '');
      const key = `reach:${h}`;
      const fromCache = () => {
        try { const c = sessionStorage.getItem(key) as any; return c === 'reachable' || c === 'unreachable' ? (c as 'reachable'|'unreachable') : null; } catch { return null; }
      };
      const cached = fromCache();
      if (cached) { if (mounted) setStatus(cached); return; }
      const timeout = (ms: number) => new Promise((_, r) => setTimeout(()=>r(new Error('timeout')), ms));
      const tryImage = (url: string) => new Promise<'ok'|'fail'>(resolve => {
        const img = new Image(); let done = false;
        const finish = (ok: boolean) => { if (done) return; done = true; resolve(ok ? 'ok' : 'fail'); };
        img.onload = () => finish(true); img.onerror = () => finish(false); img.src = url; setTimeout(()=>finish(false), 2500);
      });
      const tryFetch = async (url: string) => {
        try { const ctrl = new AbortController(); const t = setTimeout(()=>ctrl.abort(), 2000); await fetch(url, { mode: 'no-cors', signal: ctrl.signal } as any); clearTimeout(t); return true; } catch { return false; }
      };
      const setAndCache = (s: 'reachable'|'unreachable') => { try { sessionStorage.setItem(key, s); } catch {}; if (mounted) setStatus(s); };
      try {
        if (await tryImage(`https://${h}/favicon.ico`) === 'ok') return setAndCache('reachable');
        if (await tryImage(`http://${h}/favicon.ico`) === 'ok') return setAndCache('reachable');
        if (await tryFetch(`https://${h}`)) return setAndCache('reachable');
        if (await tryFetch(`http://${h}`)) return setAndCache('reachable');
        return setAndCache('unreachable');
      } catch { return setAndCache('unreachable'); }
    };
    run();
    return () => { mounted = false; };
  }, [host]);

  if (status === 'unknown') return null;
  return (
    <span
      className={`reachability-badge ${status}`}
      title={status === 'reachable'
        ? 'Client Reachable: Our system can connect to this site from the browser'
        : 'Client Unreachable: Our system could not connect to the site (could be blocking bots or offline)'}
    >
      {status === 'reachable' ? 'Client ✓' : 'Client ✗'}
    </span>
  );
}

